<template>
  <Card :class="{ 'diceRollerPopover': true, 'isVisible': visible }">
    <div class="delete is-large" @click="closePopover" />

    <div class="block">
      <div class="rollHistory">
        <span v-for="(item, i) in history" :key="i">{{ item.outcome }}</span>
      </div>
      <DiceRoll ref="diceRoller" :roll="roll" :character="character" :computed="computed" />
    </div>

    <div class="block">
      <div>
        <div class="field has-addons fillSpace">
          <div v-for="faces in [ 4, 6, 8, 10, 12, 20, 100 ]" :key="faces" class="control">
            <button class="button is-small" @click="addDice(faces)">d{{ faces }}</button>
          </div>
        </div>

        <div class="field has-addons fillSpace">
          
          <div v-for="ability in [ 'str', 'dex', 'con', 'int', 'wis', 'char' ]" :key="ability" class="control">
            <button class="button is-small" @click="addAbility(ability)">{{ ability.toUpperCase() }}</button>
          </div>
        </div>

        <div class="field">
          <div class="level">
            <div class="level-item level-left">
              <div class="field has-addons">
                <div class="control">
                  <button class="button is-small" :disabled="useProf" @click="addAbility('prof')">Prof.</button>
                </div>
                <div class="control" v-if="bonuses.inspiration">
                  <button class="button is-small" :disabled="useInspiration || removeInspirationOnClose" @click="addInspiration()">Inspiration</button>
                </div>
              </div>
            </div>
            <div class="level-item level-right">
              <div class="field has-addons">
                <div class="control">
                  <input type="number" class="input is-small" v-model.number="value" :min="1" />
                </div>
                <div class="control">
                  <button class="button is-small" @click="addValue(value)">Add Value</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="level">
            <div class="level-item level-right">
              <div class="buttons">
                <button class="button" @click="reset">Reset</button>
                <a class="button is-primary" @click="rollDice" :disabled="!roll.length ? true : null">Roll</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import { defineComponent, ref, inject } from 'vue'

import Card from '@/components/Card'
import DiceRoll from '@/components/DiceRoll'

export default defineComponent({
  props: {
    visible: {
      type: Boolean
    }
  },

  components: {
    Card,
    DiceRoll
  },

  setup (props, { emit }) {
    const character = inject('character')
    const computed = inject('computedCharacter')

    const value = ref(1)
    const outcome = ref(null)
    const roll = ref([])
    const history = ref([])
    const diceRoller = ref(null)
    const useProf = ref(false)
    const useInspiration = ref(false)
    const removeInspirationOnClose = ref(false)

    const rollDice = () => {
      const result = diceRoller.value.rollDice()
      outcome.value = result.outcome

      history.value.push(result)
      if (history.value.length > 10) {
        history.value.shift()
      }

      if (useInspiration.value) removeInspirationOnClose.value = true
    }

    const softReset = () => {
      if (outcome.value === null) return
      diceRoller.value.reset()
      roll.value = []
      outcome.value = null
      useProf.value = false
      useInspiration.value = false
    }

    const reset = () => {
      diceRoller.value.reset()
      history.value = []
      roll.value = []
      outcome.value = null
      value.value = 0
      useProf.value = false
      useInspiration.value = false
    }

    const addDice = (faces) => {
      softReset()
      roll.value.push(`+1d${faces}`)
    }
    const addAbility = (key) => {
      softReset()
      if (key === 'prof') useProf.value = true
      roll.value.push(`+${key}`)
    }
    const addValue = (val) => {
      softReset()
      if (val < 0) roll.value.push(`-${val}`)
      else roll.value.push(`+${val}`)
    }
    const addInspiration = () => {
      softReset()
      roll.value.push(`+1`)
      useInspiration.value = true
    }

    const closePopover = () => {
      if (removeInspirationOnClose.value) {
        removeInspirationOnClose.value = false
        emit('removeInspiration')
      }
      emit('close')
    }

    return {
      character,
      computed,
      ...computed,
      roll,
      diceRoller,
      rollDice,
      reset,
      value,
      addDice,
      addAbility,
      addValue,
      history,
      addInspiration,
      closePopover,
      useProf,
      useInspiration,
      removeInspirationOnClose
    }
  }
})
</script>

<style lang="sass" scoped>
.diceRollerPopover
  position: fixed
  top: 1rem
  right: 1rem
  z-index: 99999999
  &:not(.isVisible)
    display: none

.delete
  position: absolute
  top: 1rem
  right: 1rem

.fillSpace
  width: 100%
  .control
    flex: 1
  .button
    width: 100%

.rollHistory
  font-size: 80%
  font-family: 'Roboto'
  font-weight: bold
  margin-bottom: 0.5rem
  display: flex
  &:empty::after
    content: '- No History -'
    opacity: 0.5
  > span
    display: inline-flex
    margin-right: 0.5rem
</style>